import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import Gifting from './Gifting';
import { currentFlowTypeEnum } from '../common/components/constants';
import { getAllProgramsInitiate } from '../../actions/programs';

const mapStateToProps = state => {
  const programsData = _get(state, 'programs', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);

  return {
    currentFlow: currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD,
    selectedWorkspace,
    viewOnlyMode,
    programsData,
    fetchingPrograms:
      _get(state, 'apiState.GET_PROGRAMS.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAMS.isIdle', false),
    fetchedPrograms: _get(state, 'apiState.GET_PROGRAMS.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllPrograms: payload => dispatch(getAllProgramsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Gifting);
